/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFAttributesItem
 */
export interface CRSFAttributesItem {
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    AdobeTags?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    CDimensions?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    CGoals?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    CMetrics?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    Followers?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    GTMTags?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    MJRank?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    MJTLDRank?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    ProductCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    QubitTags?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    RefIP?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    RefSN?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    Sitemap?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFAttributesItem
     */
    TealiumTags?: number;
}

/**
 * Check if a given object implements the CRSFAttributesItem interface.
 */
export function instanceOfCRSFAttributesItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFAttributesItemFromJSON(json: any): CRSFAttributesItem {
    return CRSFAttributesItemFromJSONTyped(json, false);
}

export function CRSFAttributesItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFAttributesItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'AdobeTags': !exists(json, 'AdobeTags') ? undefined : json['AdobeTags'],
        'CDimensions': !exists(json, 'CDimensions') ? undefined : json['CDimensions'],
        'CGoals': !exists(json, 'CGoals') ? undefined : json['CGoals'],
        'CMetrics': !exists(json, 'CMetrics') ? undefined : json['CMetrics'],
        'Followers': !exists(json, 'Followers') ? undefined : json['Followers'],
        'GTMTags': !exists(json, 'GTMTags') ? undefined : json['GTMTags'],
        'MJRank': !exists(json, 'MJRank') ? undefined : json['MJRank'],
        'MJTLDRank': !exists(json, 'MJTLDRank') ? undefined : json['MJTLDRank'],
        'ProductCount': !exists(json, 'ProductCount') ? undefined : json['ProductCount'],
        'QubitTags': !exists(json, 'QubitTags') ? undefined : json['QubitTags'],
        'RefIP': !exists(json, 'RefIP') ? undefined : json['RefIP'],
        'RefSN': !exists(json, 'RefSN') ? undefined : json['RefSN'],
        'Sitemap': !exists(json, 'Sitemap') ? undefined : json['Sitemap'],
        'TealiumTags': !exists(json, 'TealiumTags') ? undefined : json['TealiumTags'],
    };
}

export function CRSFAttributesItemToJSON(value?: CRSFAttributesItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AdobeTags': value.AdobeTags,
        'CDimensions': value.CDimensions,
        'CGoals': value.CGoals,
        'CMetrics': value.CMetrics,
        'Followers': value.Followers,
        'GTMTags': value.GTMTags,
        'MJRank': value.MJRank,
        'MJTLDRank': value.MJTLDRank,
        'ProductCount': value.ProductCount,
        'QubitTags': value.QubitTags,
        'RefIP': value.RefIP,
        'RefSN': value.RefSN,
        'Sitemap': value.Sitemap,
        'TealiumTags': value.TealiumTags,
    };
}

